// Port of api/fuel/app/classes/controller/api/monty/listing/suggest.php
import {
	buildSuggestFilter,
	currentEdition,
	currentUserId,
	gameSummary,
	loadListingEdition,
	loadOwnedListing,
	ok,
	parseGameIndex,
	unauthorised
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var edition = null
	var results = []
	var existing = {}
	var suggestions = []

	if (!userId) return unauthorised()
	if (!listing || listing.get_template()) return unauthorised()

	edition = loadListingEdition(listing, params.edition) || currentEdition(listing)
	if (!edition) return Promise.reject({ error: 120, offline: true })

	results = buildSuggestFilter(listing, params)
	parseGameIndex(edition.get_index_games()).forEach(function(id) {
		existing[id] = true
	})

	for (var i = 0; i < results.length; i++) {
		var game = gameSummary(results[i])
		if (game) {
			suggestions.push({
				id: game.id,
				name: game.name,
				exists: !!existing[game.id]
			})
		}
	}

	return ok({ suggestions: suggestions })
}
